import { useRef, useState, useEffect } from 'react'

import { addCreditCard, resetErrorState } from 'credit-cards/pagseguro/actions'
import { addCreditCardStateReset } from 'credit-cards/moneris/actions'
import { creditCardSuccessfullyAddedSelector, creditCardAddFailedErrorSelector } from 'credit-cards/selectors'
import { guestUserCardVerifiedSelector } from 'booking/selectors'
import { verifyGuestCreditCardResetState } from 'booking/actions'

import AddCreditCardForm from 'credit-cards/pagseguro/components/AddCreditCardForm'

import 'credit-cards/moneris/components/styles.scss'

const AddCreditCard = ({
    addCreditCard,
    addCreditCardStateReset,
    cardIsSuccessfullyAdded,
    errorMessage,
    resetErrorState,
    successCallback,
    guestUserCardIsVerified,
    verifyGuestCreditCardResetState,
    translate: t,
}) => {
    const ref = useRef(null)
    const errorMessageText = errorMessage && t(`${errorMessage}`)

    const resetForm = () => {
        if (ref.current) {
            ref.current.reset()
        }
    }

    const reloadForm = () => {
        resetForm()
        addCreditCardStateReset()
    }

    const addCreditCardHandler = (cardholdersName, encryptedCard, expDate, cardNumber) =>
        addCreditCard(cardholdersName, encryptedCard, expDate, cardNumber)

    useEffect(() => {
        resetErrorState()
        addCreditCardStateReset()
        verifyGuestCreditCardResetState()
    }, [])

    useEffect(() => {
        if (cardIsSuccessfullyAdded) {
            reloadForm()
            if (successCallback) {
                successCallback({ forceClose: true })
            }
        }
    }, [cardIsSuccessfullyAdded])

    useEffect(() => {
        if (guestUserCardIsVerified && cardIsSuccessfullyAdded && successCallback) {
            successCallback({ forceClose: true })
            addCreditCardStateReset()
        }
    }, [guestUserCardIsVerified])

    useEffect(() => {
        if (errorMessage) {
            resetForm()
        }
    }, [errorMessage])

    return (
        <>
            <AddCreditCardForm
                addCreditCardHandler={addCreditCardHandler}
                errorMessage={errorMessageText}
                resetErrorState={resetErrorState}
                customRef={ref}
            />
        </>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            cardIsSuccessfullyAdded: creditCardSuccessfullyAddedSelector,
            errorMessage: creditCardAddFailedErrorSelector,
            guestUserCardIsVerified: guestUserCardVerifiedSelector,
        }),
        { addCreditCard, addCreditCardStateReset, resetErrorState, verifyGuestCreditCardResetState }
    )
)(AddCreditCard)
